import { Bindable, nameof, NotifyProperty } from "bindable-data";
import { Language } from "../../localization/Localization";
import { SaveModel } from "./SaveModel";
import { injectable } from "@launchtray/tsyringe-async";

@injectable()
export class SettingsModel extends Bindable {
    public readonly musicEnabled: NotifyProperty<boolean>;
    public readonly sfxEnabled: NotifyProperty<boolean>;
    public readonly language: NotifyProperty<Language>;

    public constructor(
        private readonly saveModel: SaveModel
    ) {
        super();
        this.musicEnabled = new NotifyProperty(this, nameof(this, "musicEnabled"), saveModel.read("SettingsModel", "musicEnabled", "boolean", true));
        this.sfxEnabled = new NotifyProperty(this, nameof(this, "sfxEnabled"), saveModel.read("SettingsModel", "sfxEnabled", "boolean", true));
        this.language = new NotifyProperty(this, nameof(this, "language"), saveModel.read("SettingsModel", "language", "string", Language.English));
    }

    public changeLanguage(language: Language): void {
        this.language.setValue(language);
        this.saveModel.write("SettingsModel", "language", "string", language);
    }

    public setMusicEnabled(value: boolean): void {
        this.musicEnabled.setValue(value);
        this.saveModel.write("SettingsModel", "musicEnabled", "boolean", value);
    }

    public setSfxEnabled(value: boolean): void {
        this.sfxEnabled.setValue(value);
        this.saveModel.write("SettingsModel", "sfxEnabled", "boolean", value);
    }
}
